import React from "react";
const Typewriter = ({text}) => {
  return (
        <div class="typeContainer">
        <div className="typewriter">
          <h1>{text}</h1>
        </div>
        </div>
  );
};
export default Typewriter;
